module.exports = __webpack_public_path__ + "img/66_9.b65840af.png";